export const CLIENT_RESPONDED = 'Client already responded to this message: \n\n';
export const FIRST_NAME_PLACEHOLDER = '{customer.firstName}';
export const DEFAULT_FIRST_GREETING = `<p>Hey ${FIRST_NAME_PLACEHOLDER} \u2014 thanks for reaching out!</p>`;
/* currently Tecovas is the only one using this feature. Without completely ripping this out I am just setting it to
 * an empty string. If we want to make this available for all Partners then these values should be moved to the db
 * on a per partner basis.
 */
export const DEFAULT_SECOND_GREETING = '';
export const EDITOR_USAGE_MACRO = "Press 'Enter' to create a new paragraph\nUse 'Shift + Enter' to start a new line";
export const EDITOR_USAGE_REPLY =
  EDITOR_USAGE_MACRO +
  (EDITOR_USAGE_MACRO ? '\n' : '') +
  "Use 'Ctrl + S' (or 'Command + Enter' on Mac) to send your message";
export const AUTO_TRANSLATED_EDITOR_PLACEHOLDER = 'Type your message in English here for accurate translation';
export const AUTO_TRANSLATED_EDITOR_USAGE_REPLY = `${AUTO_TRANSLATED_EDITOR_PLACEHOLDER}\n\n${EDITOR_USAGE_REPLY}`;
export const DEFAULT_FORBIDDEN_TEXT = "\n\n{Wait!_have_you_understood_and_addressed_your_customer's_main_question?}";

export const ErrorStrings = {
  COUND_NOT_CREATE_MESSAGE_TO_SEND: 'Processing message to send failed.',
  COUND_NOT_FIND_TICKET_FOR_MESSAGE: 'Could not find ticket for message.',
  SELECTED_TICKET_NOT_FOUND: 'There was a problem loading the order information',
  ESCALATION_ATTEMPT_FAILED: 'Attempt to escalate ticket failed.',
  CANNOT_ESCALATE_TICKET: 'Cannot escalate ticket.',
  ADDING_NOTE_TO_TICKET_FAILED: `Could not find note's ticket.`,
  SIMPLR_ORDER_AUTO_SELECT_FAILED: `The selected ticket or Simplr Order configurations are invalid`,
  CANNOT_SET_TAGS_HISTORICAL:
    'Cannot set tags on a previous ticket. Please click "Back to conversation" before setting tags',
};

export const DISABLED_ALGOLIA_BUTTON_TOOLTIP_TEXT =
  'This feature is currently disabled. Please reach out to a Specialist if you need assistance.';
